import { useState } from "react"
import { db } from "../firebaseConect"
import { updateDoc, doc, arrayRemove } from "firebase/firestore"

export default function SharedGuestsModal({ fileId, sharedWith = [], onRemoved, onClose }) {
  const [removing, setRemoving] = useState(null)

  const handleRemove = async (email) => {
    setRemoving(email)
    try {
      await updateDoc(doc(db, "sharedFile", fileId), {
        sharedWith: arrayRemove(email),
      })
      if (onRemoved) onRemoved(email)
    } catch (error) {
      alert("Error al quitar usuario: " + error.message)
    }
    setRemoving(null)
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h4>Usuarios invitados</h4>
        <ul>
          {sharedWith.length === 0 && <li>No hay usuarios invitados.</li>}
          {sharedWith.map((email) => (
            <li key={email} style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
              <span>{email}</span>
              <button
                style={{ marginLeft: 12 }}
                disabled={removing === email}
                onClick={() => handleRemove(email)}
              >
                {removing === email ? "Quitando..." : "Quitar"}
              </button>
            </li>
          ))}
        </ul>
        <button onClick={onClose} style={{ marginTop: 12 }}>Cerrar</button>
      </div>
      <style>{`
        .modal-overlay {
          position: fixed; left: 0; top: 0; width: 100vw; height: 100vh;
          background: rgba(0,0,0,0.2); display: flex; align-items: center; justify-content: center; z-index: 1000;
        }
        .modal-content {
          background: #fff; padding: 24px 32px; border-radius: 8px; min-width: 300px;
          box-shadow: 0 2px 16px rgba(0,0,0,0.15);
        }
      `}</style>
    </div>
  )
}